/**
 * Button — universal button component
 *
 * Variants: primary | secondary | success | danger | warning | dark | ghost | soft | soft-danger | link
 * Sizes:    xs | sm | md | lg | xl
 *
 * Usage:
 *   <Button>Save</Button>
 *   <Button variant="secondary" size="sm" icon="fa-pen">Edit</Button>
 *   <Button variant="danger" size="sm" iconOnly icon="fa-trash" />
 *   <Button variant="ghost" pill>Cancel</Button>
 *   <Button loading>Saving...</Button>
 *   <Button fullWidth>Submit</Button>
 */

const Button = ({
  children,
  variant  = "primary",
  size     = "md",
  icon,
  iconRight,
  iconOnly = false,
  pill     = false,
  fullWidth= false,
  disabled = false,
  loading  = false,
  type     = "button",
  onClick,
  className= "",
  style    = {},
  title,
  "aria-label": ariaLabel,
}) => {
  const cls = [
    "fc-btn",
    `fc-btn-${size}`,
    `fc-btn-${variant}`,
    pill     ? "fc-btn-pill"      : "",
    fullWidth? "fc-btn-full"      : "",
    iconOnly ? "fc-btn-icon-only" : "",
    className,
  ].filter(Boolean).join(" ");

  const iconSize = { xs: 10, sm: 11, md: 13, lg: 15, xl: 16 }[size] || 13;

  return (
    <button
      type={type}
      className={cls}
      style={style}
      disabled={disabled || loading}
      onClick={(!disabled && !loading) ? onClick : undefined}
      title={title}
      aria-label={ariaLabel || (iconOnly && !children ? title : undefined)}
    >
      {loading
        ? <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: iconSize }} />
        : icon
          ? <i className={`fa-solid ${icon}`} style={{ fontSize: iconSize }} />
          : null
      }
      {!iconOnly && children}
      {iconRight && !loading && (
        <i className={`fa-solid ${iconRight}`} style={{ fontSize: iconSize }} />
      )}
    </button>
  );
};

export default Button;
